import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=0502ec46&scoped=true&"
import script from "./NavItem.vue?vue&type=script&lang=js&"
export * from "./NavItem.vue?vue&type=script&lang=js&"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=0502ec46&prod&lang=scss&scoped=true&"
import style1 from "./NavItem.vue?vue&type=style&index=1&id=0502ec46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0502ec46",
  null
  
)

export default component.exports